
    import { defineComponent } from 'vue'
    import { iAlert } from './AlertDefinition'
    import KnFabButton from '@/components/UI/KnFabButton.vue'
    import Listbox from 'primevue/listbox'
    import { AxiosResponse } from 'axios'
    import alertDescriptor from './AlertDefinitionDescriptor.json'

    export default defineComponent({
        name: 'alert',
        components: { KnFabButton, Listbox },
        data() {
            return {
                alertDescriptor,
                alertList: [] as iAlert[],
                loading: false,
                touched: false
            }
        },
        created() {
            this.loadAllAlerts()
        },
        methods: {
            async loadAllAlerts() {
                this.loading = true
                await this.$http
                    .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '1.0/alert/listAlert')
                    .then(
                        (response: AxiosResponse<any>) =>
                            (this.alertList = response.data.map((alert: any) => {
                                return {
                                    id: alert.id,
                                    name: alert.name,
                                    status: alert.jobStatus
                                }
                            }))
                    )
                    .finally(() => (this.loading = false))
            },
            showForm(alert: any) {
                const path = alert.value ? `/alert/${alert.value.id}` : `/alert/new-alert`
                this.$router.push(path)
            },
            deleteAlertConfirm(alertId: number) {
                this.$confirm.require({
                    message: this.$t('common.toast.deleteMessage'),
                    header: this.$t('common.toast.deleteTitle'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => this.deleteAlert(alertId)
                })
            },
            async deleteAlert(id: number) {
                await this.$http.delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '1.0/alert/' + id + '/delete').then(() => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.deleteSuccess')
                    })
                    this.$router.push('/alert')
                    this.loadAllAlerts()
                })
            },
            async handleStatus(alert) {
                if (alert.status !== 'EXPIRED') {
                    var data = 'scheduler/' + (alert.status == 'SUSPENDED' ? 'resumeTrigger' : 'pauseTrigger') + '?jobGroup=ALERT_JOB_GROUP&triggerGroup=ALERT_JOB_GROUP&jobName=' + alert.id + '&triggerName=' + alert.id
                    await this.$http.post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + data)
                    this.loadAllAlerts()
                }
            },
            closeForm() {
                if (!this.touched) {
                    this.handleClose()
                } else {
                    this.$confirm.require({
                        message: this.$t('common.toast.unsavedChangesMessage'),
                        header: this.$t('common.toast.unsavedChangesHeader'),
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.touched = false
                            this.handleClose()
                        }
                    })
                }
            },
            handleClose() {
                this.$router.replace('/alert')
            },
            reloadAlert(id) {
                this.$router.replace(`/alert/${id}`)
                this.touched = false
                this.loadAllAlerts()
            }
        }
    })
